import { AppState } from "../store";

function getIsEmptyCampaigns(state: AppState) {
  const { campaigns, error } = state.campaigns;
  const isEmpty = Boolean(campaigns && campaigns.length === 0 && !error);
  return isEmpty;
}

export default getIsEmptyCampaigns;

export type IsEmptyCampaignsType = ReturnType<typeof getIsEmptyCampaigns>;
